// Shared className for sidebar nav icons across dashboard, detail and settings.
export const ICON = 'mr-2 shrink-0 size-4 text-subtle-foreground';
